import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SeusStatusService } from '../shared/services/seus-status.service';

@Component({
  selector: 'app-acceso-denegado',
  templateUrl: './acceso-denegado.component.html',
  styleUrls: ['./acceso-denegado.component.css']
})
export class AccesoDenegadoComponent implements OnInit {

  errorInfo: any = null;
  isRetrying: boolean = false;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private seusStatusService: SeusStatusService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.tipo) {
        this.errorInfo = {
          tipo: params.tipo,
          status: params.status
        };
      }
    });
  }

  getTipoErrorTexto(): string {
    if (!this.errorInfo) return 'No está Autorizado!';
    
    switch (this.errorInfo.tipo) {
      case 'timeout':
        return 'Tiempo de espera agotado';
      case 'network':
        return 'Error de conectividad';
      case 'server':
        return 'Error del servidor';
      case 'service_unavailable':
        return 'Servicio no disponible';
      default:
        return 'Error de conexión';
    }
  }

  getMensajeError(): string {
    if (!this.errorInfo) {
      return 'Lo sentimos, su usuario no tiene permisos sobre la acción solicitada.';
    }
    return this.errorInfo.mensaje;
  }

  getDetallesError(): string {
    if (!this.errorInfo) {
      return '';
    }
    switch (this.errorInfo.tipo) {
      case 'timeout':
        return '¡Lo sentimos! Los servicios no respondieron en el tiempo esperado. Verifique su conexión e intente nuevamente.';
      case 'network':
        return '¡Lo sentimos! No se pudo establecer conexión con los servicios. Verifique su conexión a internet.';
      case 'server':
        return '¡Lo sentimos! Los servicios están experimentando problemas técnicos. Verifique sus permisos e intente nuevamente más tarde.';
      case 'service_unavailable':
        return '¡Lo sentimos! Los servicios están temporalmente fuera de servicio. Intente nuevamente más tarde.';
      default:
        return '¡Lo sentimos! Los servicios están experimentando problemas técnicos. Verifique sus permisos e intente nuevamente más tarde.';
    }
  }

  getStatus(): string {
    if (!this.errorInfo) {
      return '';
    }
    return this.errorInfo.status;
  }

  /**
   * Simplemente marca SEUS como disponible y navega al inicio
   * Si hay problemas reales de conectividad, el interceptor los detectará
   */
  reintentar(): void {
    this.isRetrying = true;
    
    // Marcar SEUS como disponible para permitir la navegación
    this.seusStatusService.markSeusAvailable();
    
    // Navegar al inicio - si hay problemas reales, el interceptor los detectará
    this.router.navigate(['']);
  }

  /**
   * Verifica si se debe mostrar el botón de reintentar
   */
  mostrarBotonReintentar(): boolean {
    return this.errorInfo && 
           (this.errorInfo.tipo === 'timeout' || 
            this.errorInfo.tipo === 'network' || 
            this.errorInfo.tipo === 'service_unavailable' ||
            this.errorInfo.tipo === 'server');
  }
}



// WEBPACK FOOTER //
// ./src/app/acceso-denegado/acceso-denegado.component.ts